import { useState, useEffect } from "react";
import "./styles/record.scss";
import { motion } from "framer-motion";
import { member } from '../../components/apipath';
import axios from "axios";

function Consultrecord() {
    const [records, setRecords] = useState({
        first_record: "",
        sec_record: "",
        third_record: ""
    });

    useEffect(() => {
        const fetchRecords = async () => {
            const auth = localStorage.getItem("auth");
            // console.log("auth from local storage:", auth); // 调试信息
    
            if (auth) {
                const authData = JSON.parse(auth);
                const mem_id = authData.mem_id;
                // console.log("mem_id from auth data:", mem_id); // 调试信息
    
                if (mem_id) {
                    try {
                        const response = await axios.get(`${member}records/${mem_id}`);
                        // console.log("Fetched records:", response.data); // 检查数据
                        if (response.data.length > 0) {
                            setRecords(response.data[0]);
                        } else {
                            console.error("No records found for the given mem_id.");
                        }
                    } catch (error) {
                        console.error("Error fetching records:", error);
                    }
                } else {
                    console.error("No mem_id found in auth data.");
                }
            } else {
                console.error("No auth data found in local storage.");
            }
        };
    
        fetchRecords();
    }, []);

    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                }}>
                        <img className="recordbg" src="../auditionImg/audition_banner.jpg"alt=""/>
                </motion.div>
            </div>
            <div className="container">
                <div className="text-center recordarea">
                    <div className="col-6 mt-5">
                        <div className="form-group">
                            <label htmlFor="firstRecord">第一次諮詢</label>
                            <textarea 
                                className="form-control" 
                                id="firstRecord" 
                                rows="5" 
                                value={records.first_record} 
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-6 mt-5">
                        <div className="form-group">
                            <label htmlFor="secRecord">第二次諮詢</label>
                            <textarea 
                                className="form-control" 
                                id="secRecord" 
                                rows="5" 
                                value={records.sec_record} 
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-6 mt-5 mb-5">
                        <div className="form-group">
                            <label htmlFor="thirdRecord">第三次諮詢</label>
                            <textarea 
                                className="form-control" 
                                id="thirdRecord" 
                                rows="9" 
                                value={records.third_record} 
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Consultrecord;